"use strict";

var filter = require("lodash/filter");
var isSentenceTooLong = require("../helpers/isValueTooLong");
/**
 * Checks for too long sentences.
 * @param {array} sentences The array with objects containing sentences and their lengths.
 * @param {number} recommendedValue The recommended maximum length of sentence.
 * @returns {array} The array with objects containing too long sentences and their lengths.
 */
module.exports = function (sentences, recommendedValue) {
    var tooLongSentences = filter(sentences, function (sentence) {
        return isSentenceTooLong(recommendedValue, sentence.sentenceLength);
    });
    return tooLongSentences;
};
//# sourceMappingURL=checkForTooLongSentences.js.map
//# sourceMappingURL=checkForTooLongSentences.js.map



//////////////////
// WEBPACK FOOTER
// ./node_modules/yoastseo/js/assessmentHelpers/checkForTooLongSentences.js
// module id = 481
// module chunks = 0